import { HistogramConfigurationProviderProps } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { HistogramPanelData } from 'features/drilldown/components/histogram/DrilldownHistogram'

const LATEST_DATA_SCHEMA_VERSION = 3

export const DEFAULT_WORK_ORDER_HISTOGRAM_PANEL_DATA: HistogramPanelData = {
  panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  title: 'Work Order Analysis',
  isPinned: true,
  selectedBarIds: [],
  groupingColumn: 'work-order.csmp_summary',
  aggregationColumn: 'work-order.jsn',
  aggregationOperation: 'sum',
  orientation: 'v',
  sortDirection: 'asc',
}

export const WORK_ORDER_HISTOGRAM_CONFIG_PROPS: HistogramConfigurationProviderProps =
  {
    defaultPanelData: DEFAULT_WORK_ORDER_HISTOGRAM_PANEL_DATA,
    latestDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  }
